import { bool, func } from 'prop-types'
import { Button, kuiperClassNames, Conditional } from '@opallabs/kuiper'

import './styles.scss'

const WorkflowPopoverHeader = ({ onClickEdit, shouldShowEdit }) => (
  <div className={kuiperClassNames('workflowPopoverHeader')}>
    <div className={kuiperClassNames('workflowPopoverHeader__titleContainer')}>
      <div className={kuiperClassNames('workflowPopoverHeader__title')}>
        Workflow
      </div>
      <Conditional condition={shouldShowEdit}>
        <Button label="Edit Workflow" onClick={onClickEdit} size="small" />
      </Conditional>
    </div>
  </div>
)

WorkflowPopoverHeader.propTypes = {
  onClickEdit: func,
  shouldShowEdit: bool,
}

export default WorkflowPopoverHeader
